module.exports = "/assets/f97fd1aa27c94f6bef2459bb3a02f39d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/UN.png
// module id = 1897
// module chunks = 0